import createSelector from "../../utils/reselect";

const changeRequestsStateData = (state) => {
  const { changeRequests } = state;
  return changeRequests || {};
};

export const getError = createSelector(changeRequestsStateData, (projects) =>
  projects.get("error")
);

export const changeRequests = createSelector(
  changeRequestsStateData,
  (changeRequests) => changeRequests.get("changeRequests")
);

export const changeRequestLoading = createSelector(
  changeRequestsStateData,
  (changeRequests) => changeRequests.get("changeRequestLoading")
);

export const changeRequestPagination = createSelector(
  changeRequestsStateData,
  (changeRequests) => changeRequests.get("changeRequestPagination")
);

export const changeRequestsLoading = createSelector(
  changeRequestsStateData,
  (changeRequests) => changeRequests.get("pageLoading")
);
